import { render, staticRenderFns } from "./ZB52.vue?vue&type=template&id=68432914&scoped=true&"
import script from "./ZB52.vue?vue&type=script&lang=js&"
export * from "./ZB52.vue?vue&type=script&lang=js&"
import style0 from "./ZB52.vue?vue&type=style&index=0&id=68432914&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68432914",
  null
  
)

export default component.exports